import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { Analytics } from '@vercel/analytics/react'
import { AuthProvider } from './context/AuthContext'
import Navbar from './components/Navbar'
import ProtectedRoute from './components/ProtectedRoute'
import AdminRoute from './components/AdminRoute'
import Home from './pages/Home'
import Login from './pages/Login'
import Register from './pages/Register'
import CampRegistration from './pages/CampRegistration'
import MyRegistration from './pages/MyRegistration'
import AdminDashboard from './pages/AdminDashboard'
import ResetPassword from './pages/ResetPassword'
import Help from './pages/Help'

const SentryRoutes = Sentry.withSentryRouting(Routes)

function Main({ children }) {
  const { pathname } = useLocation()
  // Admin dashboard uses a sidebar + dense tables — give it a wider canvas
  const width = pathname.startsWith('/admin') ? 'max-w-[1440px]' : 'max-w-6xl'
  return <main className={`${width} mx-auto px-4 py-8`}>{children}</main>
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="min-h-screen bg-surface text-on-surface">
          <Navbar />
          <Main>
            <SentryRoutes>
              {/* Public routes */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/help" element={<Help />} />

              {/* Protected routes — must be logged in */}
              <Route element={<ProtectedRoute />}>
                <Route path="/register-camp" element={<CampRegistration />} />
                <Route path="/my-registration" element={<MyRegistration />} />
              </Route>

              {/* Admin-only routes */}
              <Route element={<AdminRoute />}>
                <Route path="/admin" element={<AdminDashboard />} />
              </Route>
            </SentryRoutes>
          </Main>
        </div>
        <Analytics />
      </AuthProvider>
    </BrowserRouter>
  )
}
